/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Services from '../Components/Detail/Detail';
import axios from 'axios';
import Header from '../Components/Header/page';
import Footer from '../Components/Footer/Footer';
import { toast } from 'react-toastify';


const BarbarDetail = () => {

    const [Loader, setLoader] = useState(false);
    const { id } = useParams();

    const [data, setData] = useState()

    useEffect(() => {
        setLoader(true)
        axios
            .get(`https://api.kazbarber.com/api/barbers/${id}`)
            .then((response) => {
                setLoader(false)
                console.log(response.data, 'data1');
                setData(response.data);
            })
            .catch((error) => {
                setLoader(false)
                console.error('Error fetching barber data:', error);
                toast.error('Something went wrong', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            });
    }, []);


    return (
        <>
            <Header />
            {Loader ?

                <div className='loader-overlay'>
                    <img src='/assets/images/fancybox_loading@2x.gif' alt='loader' />
                </div>
                :
                <>
            <section id="detail" class="banner-slider-initial">
                {/* <!--slider--> */}
                <div class="banner">
                    <div class="" id="banner-slide-show">
                        <div class="banner-detail center">
                            <h1>Book Your Barber</h1>
                        </div>
                    </div>
                </div>
            </section>

            <Services data={data?.data || {}} />
</>
            }

<Footer />
        </>
    )

}

export default BarbarDetail



